import { render, staticRenderFns } from "./public-cooperation.vue?vue&type=template&id=386fd767&scoped=true"
import script from "./public-cooperation.vue?vue&type=script&lang=js"
export * from "./public-cooperation.vue?vue&type=script&lang=js"
import style0 from "./public-cooperation.vue?vue&type=style&index=0&id=386fd767&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386fd767",
  null
  
)

export default component.exports